import { render, staticRenderFns } from "./CategoryBanner.vue?vue&type=template&id=45f930c6&"
import script from "./CategoryBanner.ts?vue&type=script&lang=ts&"
export * from "./CategoryBanner.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports